import { FC } from "react"
import { MUIIcon } from "./MUIIcon"
import clsx from "clsx"
import { isObject } from "formik"
import { isString } from "react-bootstrap-typeahead/types/utils"

interface IAlertMessage {
    message?: string,
    type?: 'Info' | 'Warning' | 'Error'
    show?: boolean,
    className?: string,
    children?: React.ReactNode
}
export const AlertMessage: FC<IAlertMessage> = ({
    message,
    type = 'Info',
    show = true,
    className,
    children
}) => {
    if (show === false) return <></>

    if (isObject(message) && !isString(message)) {
        console.error("Invalid message", message);
        return <></>
    }

    return (
        <div className={clsx(className, "alert fs-7 px-5 py-3", {
            "alert-danger fst-italic": type === "Error",
            "alert-warning fst-italic": type === "Warning",
            "alert-info": type === "Info"
        })}>
            <div className="d-flex align-items-center lh-2">
                <MUIIcon iconName={clsx({
                    'ReportProblemOutlined': type === 'Error',
                    'WarningAmber': type === 'Warning',
                    'InfoOutlined': (type === 'Info' || !type)
                })} className="me-2 fs-2" />
                <span>{message}</span>
                {children}
            </div>
        </div>
    )
}

interface IMessageProps {
    message?: string;
    show?: boolean;
    className?: string;
    children?: React.ReactNode;
}

export const InfoMessage: FC<IMessageProps> = (props) => {
    return (
        <AlertMessage {...props} type="Info" />
    );
};

export const WarningMessage: FC<IMessageProps> = (props) => {
    return (
        <AlertMessage {...props} type="Warning" />
    );
};

export const ErrorMessage: FC<IMessageProps> = (props) => {
    return (
        <AlertMessage {...props} type="Error" />
    );
};